module.exports = __webpack_public_path__ + "img/vietlott.6f6440a6.png";